import { Button } from "@meiden-connect/ui";
import { useEffect, useState } from "react";
import { generateCanvasId } from "../../../lib/canvas-id";
import { navigate } from "../../../router";
import { useCanvasDocStore } from "../store/canvas-doc-store";
import { useCanvasOpDispatcherContext } from "../dispatcher-context";

interface Props {
  readonly canvasId: string;
}

// 左上のフローティングアプリメニュー。
// TOP / 新規ボタンに加えて、現在のキャンバス名をその場で編集できるようにする。
export function AppMenu({ canvasId: _canvasId }: Props): JSX.Element {
  const title = useCanvasDocStore((s) => s.meta.title);
  const dispatcher = useCanvasOpDispatcherContext();
  const [draftTitle, setDraftTitle] = useState(title);

  useEffect(() => {
    setDraftTitle(title);
  }, [title]);

  const commitTitle = (): void => {
    const next = draftTitle.trim() || "無題のキャンバス";
    setDraftTitle(next);
    if (next !== title) {
      dispatcher.updateCanvasMeta({ title: next });
    }
  };

  return (
    <div className="canvas-app-menu">
      <Button type="button" variant="action" onClick={() => navigate("/")} aria-label="ダッシュボードへ戻る">
        ↑ TOP
      </Button>
      <Button
        type="button"
        variant="action"
        onClick={() => navigate(`/c/${generateCanvasId()}`)}
        aria-label="新規キャンバスを作成"
      >
        + 新規
      </Button>
      <label className="canvas-title-editor">
        <span>キャンバス名</span>
        <input
          aria-label="キャンバス名"
          value={draftTitle}
          onChange={(event) => setDraftTitle(event.currentTarget.value)}
          onBlur={commitTitle}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.currentTarget.blur();
            }
          }}
        />
      </label>
    </div>
  );
}
